import './cmsSearchBridge';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './theme.css';
import reportWebVitals from './reportWebVitals';

const THEME_KEY = 'ams_theme';
const isLiteRoute = window.location.pathname.startsWith('/affichage');

function readTheme() {
  const queryTheme = new URLSearchParams(window.location.search).get('theme');
  if (queryTheme === 'light' || queryTheme === 'dark') return queryTheme;

  const savedTheme = localStorage.getItem(THEME_KEY);
  if (savedTheme === 'light' || savedTheme === 'dark') return savedTheme;

  const cookieTheme = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${THEME_KEY}=`))
    ?.split('=')[1];
  return cookieTheme === 'light' ? 'light' : 'dark';
}

function applyTheme(theme) {
  if (isLiteRoute || (theme !== 'light' && theme !== 'dark')) return;
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(THEME_KEY, theme);

  const domain = window.location.hostname.endsWith('.amservices.eu')
    ? '; Domain=.amservices.eu'
    : '';
  document.cookie = `${THEME_KEY}=${theme}; Path=/; Max-Age=31536000; SameSite=Lax${domain}`;
}

applyTheme(readTheme());

window.addEventListener('message', (event) => {
  if (event.data?.type === 'ams-theme') applyTheme(event.data.theme);
});

window.addEventListener('storage', (event) => {
  if (event.key === THEME_KEY) applyTheme(event.newValue);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// À mettre tout en bas de ton src/index.js (CRM)
// index.js

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // On indique au navigateur où se trouve le fichier
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker enregistré avec succès ! Portée :', registration.scope);
      })
      .catch(error => {
        console.error('L\'enregistrement du Service Worker a échoué :', error);
      });
  });
}
